import { connect } from 'react-redux'
import { getQuoteEmailData } from './selectors'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import AppointmentIsNotEnable from './AppointmentIsNotEnable'

const mapStateToProps = state => ({
  phoneNumber: getCurrentStorePhoneNumber(state),
  quoteEmailData: getQuoteEmailData(state)
})

export default connect(mapStateToProps)(AppointmentIsNotEnable)
